var _rect, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6777_100465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6777_100465)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6777_100465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2269 5.00094C16.6361 5.17947 19.9652 7.13685 22.1242 11.0298C22.4081 11.5409 22.3901 12.0046 22.1101 12.5119C20.3955 15.6124 17.8447 17.5955 14.3512 18.2775C9.51044 19.2228 4.87515 17.0894 2.40274 12.8215C2.32825 12.6917 2.26917 12.553 2.19211 12.4246C1.92624 11.9789 1.94422 11.5422 2.18697 11.0876C3.71922 8.21315 6.04008 6.30201 9.17393 5.41065C10.1629 5.12938 11.1814 4.98168 12.2269 5.00094ZM12.1639 16.8505C14.9176 16.8903 17.313 14.6311 17.2655 11.7657C17.2128 8.61772 14.9009 6.5987 11.9893 6.69117C9.17393 6.78108 7.08812 8.8412 7.07528 11.8749C7.06372 14.6042 9.44879 16.8955 12.1639 16.8492V16.8505Z",
    fill: "#054BC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.92014 10.9171C9.02289 10.9595 9.08968 10.9851 9.15518 11.016C9.79865 11.3242 10.568 11.2138 11.065 10.7398C11.6083 10.2197 11.7547 9.49143 11.4542 8.80301C11.3322 8.5243 11.3746 8.45237 11.6854 8.40485C14.0615 8.04523 16.0677 10.271 15.4653 12.5983C15.0838 14.0702 13.7815 15.1054 12.2865 15.126C10.7247 15.1478 9.32986 14.1601 8.92143 12.7011C8.76217 12.1334 8.75574 11.5413 8.92143 10.9171H8.92014Z",
    fill: "#054BC7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6777_100465"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.329,
    height: 13.5,
    fill: "white",
    transform: "translate(2 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.ddbd407815e20f7ed6361d484b7f5b80.svg";
export { ForwardRef as ReactComponent };